// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1KEWT","productName":"Table_productName__TFe19"};